import * as React from 'react';
import { Link } from "react-router-dom";
import ReactHtmlParser from 'react-html-parser';
import { Slug } from '@fnv-core/utils';
import { FormControlHelpers } from '../../formcontrols/helpers/FormControlHelpers';
import { StringHelpers } from '../../helpers/StringHelpers';

export interface IGridColumnProps {
    visible : boolean;
    data : any;
    cssClasses : string;
    addValueAsCssClass : boolean;
    dataType : string;
    currencyFormat : string;
    decimalSeparator : string;
    isLink: string;
    url: string;
    valuesObject? : any;
    format: string;
    icon: string;
}

export const GridColumn = (props : IGridColumnProps) => {
    let data = props.data;
    let url = props.url;
    
    if (props.valuesObject) {
        if (props.format) {
            data = StringHelpers.replacePropertiesInUrl(props.format, props.valuesObject, true);
        }
        if (props.isLink) {
            url = StringHelpers.replacePropertiesInUrl(url, props.valuesObject, true);
        }
    }
    if (props.dataType !== undefined && props.dataType !== "") {
        data = FormControlHelpers.convertValueToType(data, {
            dataType: props.dataType,
            decimalSeparator: props.decimalSeparator,
            currencyFormat: props.currencyFormat
        });
    }
    const orgData = data;
    data = ReactHtmlParser(data ? data : "-");

    return <div 
        className={"mijn-fnv-grid__column " + 
        props.cssClasses + " " + (props.visible ? "" : "hidden") +
        (props.addValueAsCssClass ? "mijn-fnv-grid__column-" + Slug.fromString(orgData) : "")
        }>{props.icon !== "" && !props.isLink ? <span className={"icon icon-" + props.icon}></span> : ""}{!!props.isLink ? 
            <Link to={url}>{props.icon !== "" ? <span className={"icon icon-" + props.icon}></span> : ""}{data}</Link> : <span>{data}</span>}
    </div>;   
};